import Link from 'next/link';
import { FC, useMemo } from 'react';
import { BusinessIndustries } from '../../types/BusinessIndustries';

import classNames from 'classnames';
import Image from 'next/image';
import { replaceOrAddLocale, useLocale } from '../../helpers/LangHelper';
import styles from './industries-item.module.scss';

interface IndustriesItemProps extends BusinessIndustries {
    reversed?: boolean;
    hide?: boolean;
    showQuote?: boolean;
    showLearnMore?: boolean
}

export const IndustriesItem: FC<IndustriesItemProps> = (props) => {
    const { icon = '', name, description, bannerImage, reversed, hide, builderPage, quote, video, showQuote, showLearnMore } = props;
    const { locale } = useLocale();

    const url = useMemo(() => {
        if (!builderPage?.value?.data) return '';
        return replaceOrAddLocale((builderPage?.value.data as any).url, locale);
    }, [locale, builderPage]);

    return (
        <div className={classNames(styles.container, { [styles.reversed]: reversed, [styles.hide]: hide })}>
            <div className={styles.content}>
                <div className={styles.title}>
                    <div className={styles.iconBox}>
                        <div className={styles.icon}>
                            <Image
                                src={icon}
                                alt=""
                                style={{ objectFit: 'contain', objectPosition: 'center' }}
                                fill
                                sizes="(max-width: 638px) 98vw,  (max-width: 998px) 43vw, 46vw"
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </div>
                    </div>
                    <div>{name}</div>
                </div>
                <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }} />
                {showLearnMore && url ? (
                    <Link className={styles.link} href={url} target="_blank">
                        Learn more
                    </Link>
                ) : null}
            </div>
            <div className={styles.banner}>
                {bannerImage ? (
                    <Image
                        src={bannerImage}
                        alt=""
                        style={{ objectFit: 'cover', objectPosition: 'bottom' }}
                        fill
                        sizes="(max-width: 638px) 98vw,  (max-width: 998px) 43vw, 46vw"
                        loading={'eager'}
                        loader={({ src, width, quality }) => {
                            return `${src}?width=${width}&quality=${quality ?? 75}`;
                        }}
                    />
                ) : null}
                {showQuote && quote ? (
                    <div className={styles.bannerOverlay}>
                        <div className={styles.quoteContent} dangerouslySetInnerHTML={{ __html: quote.content || '' }} />
                        {quote.author ? <div className={styles.quoteAuthor}>{quote.author}</div> : null}

                        {quote.company || video ? (
                            <div className={styles.bannerFooter}>
                                {quote.company ? <div className={styles.quoteCompany}>{quote.company}</div> : <div />}

                                {video ? (
                                    <Link href={video} target="_blank">
                                        <svg width="41" height="44" viewBox="0 0 41 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.45128 44C7.11993 44 5.78864 43.6546 4.5547 42.995C1.92447 41.5815 0.300781 38.8487 0.300781 35.8647V8.12856C0.300781 5.14452 1.92447 2.41209 4.5547 0.998599C7.08752 -0.383483 10.1074 -0.320922 12.5753 1.12398L36.1824 14.9763C38.6827 16.4526 40.2089 19.0597 40.2089 21.9809C40.2089 24.9021 38.7152 27.5092 36.1824 28.9855L12.5753 42.8378C11.2764 43.5917 9.88005 43.9686 8.45128 43.9686V44ZM8.45128 6.30686C8.15903 6.30686 7.93172 6.40128 7.73689 6.49551C7.1524 6.80962 6.79518 7.43755 6.79518 8.16V35.8961C6.79518 36.6186 7.1524 37.2151 7.73689 37.5606C8.06161 37.7491 8.61368 37.8747 9.19817 37.5606L32.8053 23.7087C33.6171 23.2375 33.6821 22.4207 33.6821 22.0752C33.6821 21.7297 33.5846 20.913 32.8053 20.4418L9.19817 6.58946C8.93839 6.4324 8.67858 6.36975 8.45128 6.36975V6.30686Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </Link>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
